import { makeStyles } from '@material-ui/core/styles'
import { indigo, grey, red, amber, green, blue } from '@material-ui/core/colors'

const drawerWidth = 240
const footer = {
  textAlign: 'center',
  fontSize: '12px !important',
  bottom: 0,
  width: '100%',
  left: 0,
  border: 0,
  padding: '10px 15px !important',
}
const useStyles = makeStyles((theme) => ({
  "@global tbody tr:nth-child(even)": {
    background: "#f6f6f6"
  },
  "@global .MuiSelect-select:focus": {
    backgroundColor: 'transparent !important'
  },
  '@global .MuiTableSortLabel-active': {
    color: `${theme.palette.primary.contrastText} !important`
  },
  '@global .MuiTableSortLabel-icon': {
    color: 'rgba(255, 255, 255, 0.75) !important'
  },
  '@global .MuiTableSortLabel-root:hover': {
    color: 'rgba(255, 255, 255, 0.75) !important'
  },
  themedButton: {
    background: `linear-gradient(45deg, ${theme.palette.primary.light} 30%, ${theme.palette.primary.main} 90%)`,
    boxShadow: `0 3px 5px 2px ${theme.palette.primary.light}50`,
    '&:disabled': {
      background: `${theme.palette.action.disabled} !important`,
      color: `${theme.palette.primary.contrastText} !important`
    }
  },
  cardnumberButton: {
    background: `linear-gradient(45deg, #4c2e99 30%,  #4c2e99 90%)`,
    boxShadow: `0 3px 5px 2px  #4c2e99 50`,
    '&:disabled': {
      background: `${theme.palette.action.disabled} !important`,
      color: `#4c2e99 !important`
    }
  },
  programButton: {
    background: `linear-gradient(45deg, #164771 30%,  #164771 90%)`,
    boxShadow: `0 3px 5px 2px  #164771 50`,
    '&:disabled': {
      background: `${theme.palette.action.disabled} !important`,
      color: `#164771 !important`
    }
  },
  groupButton: {
    background: `linear-gradient(45deg, #2a687c 30%, #2a687c 90%)`,
    boxShadow: `0 3px 5px 2px #2a687c 50`,
    '&:disabled': {
      background: `${theme.palette.action.disabled} !important`,
      color: `${theme.palette.primary.contrastText} !important`
    }
  },
  root: {
    display: 'flex',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    '& img': {
      verticalAlign: 'middle !important'
    }
  },
  invalid: {
    color: red[500],
  },
  primarytheme: {
    color: theme.palette.primary.main
  },
  primaryBgTheme: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
    '& button': {
      color: `${theme.palette.primary.contrastText} !important`
    }
  },
  textField: {
    color: theme.palette.type === "dark" ? "#FFFFFF!important" : "#000000!important"
  },
  small: {
    width: `${theme.spacing(3)}px !important`,
    height: `${theme.spacing(3)}px !important`,
  },
  medium: {
    width: `${theme.spacing(4)}px !important`,
    height: `${theme.spacing(4)}px !important`,
  },
  large: {
    width: `${theme.spacing(7)}px !important`,
    height: `${theme.spacing(7)}px !important`,
  },
  smallFont: {
    fontSize: '0.85rem !important'
  },
  grey_800: {
    color: `${grey[800]} !important`
  },
  alertBox: {
    width: theme.spacing(40)
  },
  popperContent: {
    padding: `${theme.spacing(2)}px !important`
  },
  popperButton: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  bgInfo: {
    background: 'linear-gradient(55deg, rgba(7,42,99,1) 0%, rgba(72,184,189,1) 100%)',
    filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr="#072a63",endColorstr="#48b8bd",GradientType=1)',
    color: '#fff',
    padding: '1rem!important',
    marginBottom: '.5rem!important'
  },
  dropdownMenu: {
    top: '100%',
    zIndex: '1000',
    minWidth: '10rem',
    fontSize: '.875rem',
    color: '#212529',
    textAlign: 'left',
    listStyle: 'none',
    width: theme.spacing(40)
  },
  listItemIcon: {
    '& svg': {
      fontSize: '1.25rem'
    }
  },
  smallWidthItemIcon: {
    minWidth: theme.spacing(2.25),
    '& svg': {
      fontSize: '0.85rem'
    }
  },
  linkList: {
    color: indigo[500],
    '& svg': {
      color: indigo[500]
    }
  },
  appBar: {
    zIndex: `${theme.zIndex.drawer + 1} !important`,
  },
  dummyToolBar: {
    marginBottom: `${theme.spacing(0)}px !important`
  },
  drawer: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    }
  },
  drawerOpen: {
    width: drawerWidth,
    transition: `${theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    })} !important`,
    backgroundColor: `${theme.palette.background.paper} !important`,
    boxShadow: `${theme.shadows[4]} !important`,
    '& $menuList': {
      paddingLeft: theme.spacing(3)
    },
    '& ul': {
      paddingRight: theme.spacing(3)
    }
  },
  drawerClose: {
    transition: `${theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })} !important`,
    overflowX: 'hidden',
    width: theme.spacing(6.5),
    backgroundColor: `${theme.palette.background.paper} !important`,
    boxShadow: `${theme.shadows[4]} !important`,
    '& $menuList': {
      paddingLeft: theme.spacing(1.5)
    },
    '& ul': {
      paddingRight: theme.spacing(0)
    }
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[4],
    '& ul': {
      paddingRight: theme.spacing(3)
    }
  },
  drawerContainer: {
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: `100vh !important`,
  },
  contentShift: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: -drawerWidth + theme.spacing(6.5),
    height: `100vh !important`,
  },
  paddedMenuMobile: {
    padding: theme.spacing(1.5),
    '& img': {
      verticalAlign: 'middle !important'
    }
  },
  paddedMenu: {
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px !important`,
    marginBottom: `${theme.spacing(1)}px !important`
  },
  marginRight1: {
    marginRight: theme.spacing(-1) - 2
  },
  marginTop2: {
    marginTop: theme.spacing(2)
  },
  marginBottom2: {
    marginBottom: theme.spacing(2)
  },
  menuList: {
    borderRadius: '0 50px 50px 0 !important',
    "&:hover": {
      backgroundColor: `${theme.palette.primary.light} !important`,
      color: `${theme.palette.primary.contrastText} !important`,
      "& svg": {
        color: `${theme.palette.primary.contrastText} !important`
      },
      "& $smallFont": {
        fontWeight: `${600} !important`
      }
    }
  },
  selected: {
    borderRadius: '0 50px 50px 0 !important',
    backgroundColor: `${theme.palette.primary.light} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
    "& svg": {
      color: `${theme.palette.primary.contrastText} !important`
    },
    "& $smallFont": {
      fontWeight: `${600} !important`
    }
  },
  menuIcon: {
    minWidth: `${theme.spacing(5)}px !important`
  },
  menuLink: {
    textDecoration: 'none',
    color: 'inherit'
  },
  menuLinkPrimary: {
    color: theme.palette.primary.dark
  },
  mainRoot: {
    width: '100%'
  },
  dialogButton: {
    margin: theme.spacing(0),
    padding: theme.spacing(1),
  },
  searchContentRoot: {
    flexGrow: 1,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
  },
  searchContentPaper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },

  //#region footer
  footerDark: {
    ...footer,
    position: 'fixed !important',
    color: '#fff !important',
    background: 'linear-gradient(90deg, rgba(10, 36, 83, 1) 0%, rgba(45, 115, 132, 1) 100%)',
    filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr = "#0a2453", endColorstr = "#2d7384", GradientType = 1)'
  },
  footerLight: {
    ...footer,
    color: '#6e6e6ea6 !important',
    marginTop: theme.spacing(2)
  },
  //#endregion

  //#region login-page
  loginContainer: {
    background: 'linear-gradient(55deg, rgba(7,42,99,1) 0%, rgba(72,184,189,1) 100%) !important',
    filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr="#072a63",endColorstr="#48b8bd",GradientType=1) !important',
    height: '100vh !important'
  },
  loginBox: {
    height: '65vh !important',
    background: 'transparent !important',
    '& img': {
      width: '100%',
      height: '100%',
      borderRadius: '20px 0 0 20px',
      boxShadow: `${theme.shadows[4]} !important`
    },

    [theme.breakpoints.between('sm', 'md')]: {
      height: '50vh !important',
      '& img': {
        borderRadius: '20px 0 0 20px',
        boxShadow: `${theme.shadows[4]} !important`
      }
    },
    [theme.breakpoints.up('md')]: {
      height: '65vh !important'
    },
    [theme.breakpoints.between(425, 600)]: {
      width: '50vh !important',
      height: '30vh !important',
      '& img': {
        height: '100% !important',
        objectFit: 'none',
        borderRadius: '20px 20px 0 0',
        boxShadow: `${theme.shadows[4]} !important`
      }
    },
    [theme.breakpoints.between(321, 424)]: {
      width: '42vh !important',
      height: '30vh !important',
      '& img': {
        height: '100% !important',
        objectFit: 'none',
        borderRadius: '20px 20px 0 0',
        boxShadow: `${theme.shadows[4]} !important`
      }
    },
    [theme.breakpoints.between(0, 321)]: {
      width: '38vh !important',
      height: '30vh !important',
      '& img': {
        height: '100% !important',
        objectFit: 'none',
        borderRadius: '20px 20px 0 0',
        boxShadow: `${theme.shadows[4]} !important`
      }
    }
  },
  loginField: {
    backgroundColor: theme.palette.background.default,
    height: '65vh !important',
    boxShadow: `${theme.shadows[4]} !important`,
    borderRadius: '0 20px 20px 0',
    padding: theme.spacing(4, 12),
    [theme.breakpoints.between(656, 960)]: {
      height: '50vh !important',
      padding: theme.spacing(4, 10)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 10)
    },
    [theme.breakpoints.between(600, 656)]: {
      height: '50vh !important',
      padding: theme.spacing(4, 7)
    },
    [theme.breakpoints.between(424, 599)]: {
      width: '50vh !important',
      borderRadius: '0 0 20px 20px',
      padding: theme.spacing(3, 7)
    },
    [theme.breakpoints.between(321, 424)]: {
      width: '42vh !important',
      height: '44vh !important',
      borderRadius: '0 0 20px 20px',
      padding: theme.spacing(0, 7),
      '& img': {
        width: theme.spacing(13)
      },
      '& h5': {
        fontSize: '1.25rem'
      }
    },
    [theme.breakpoints.between(0, 321)]: {
      width: '38vh !important',
      height: '44vh !important',
      borderRadius: '0 0 20px 20px',
      padding: theme.spacing(0, 7),
      '& img': {
        width: theme.spacing(13)
      },
      '& h5': {
        fontSize: '1.25rem'
      }
    }
  },
  //#endregion

  //#region CardDetails Profile Begin
  chPaper: {
    padding: `${theme.spacing(2.5)}px !important`
  },
  chPaperInner: {
    padding: `${theme.spacing(1.875)}px !important`,
    '& img.imgProfile': {
      margin: `${theme.spacing(1.875)}px ${theme.spacing(0)} !important`
    }
  },
  chPaperH1_400: {
    fontSize: '1.6em !important',
    fontWeight: '400 !important',
    lineHeight: '1.2 !important',
    color: `${grey[700]} !important`
  },
  chValue: {
    color: '#555 !important',
    fontWeight: 'bold !important',
    margin: `${theme.spacing(0.25)}px ${theme.spacing(0)} !important`
  },
  chCTA: {
    marginTop: `${theme.spacing(1.25)}px !important`
  },
  chAmount: {
    fontWeight: 'bold !important',
    lineHeight: `${theme.spacing(2)}px !important`,
  },
  chDated: {
    color: '#7b7b7b !important',
    whiteSpace: 'normal !important'
  },
  hrLine: {
    margin: `${theme.spacing(1)}px ${theme.spacing(0)} !important`,
    // padding: `${theme.spacing(0)}px !important`
  },
  chCTAContainer: {
    padding: `${theme.spacing(1.5)}px  ${theme.spacing(0.5)}px!important`,
  },
  chBtn: {
    fontSize: '0.6rem !important',
    color: `${theme.palette.primary.contrastText} !important`
  },
  cardTranBtn: {
    padding: `${theme.spacing(3)}px !important`
  },
  chTransactionBtn1: {
    background: '#154672 !important',
    textTransform: 'none !important',
  },
  chTransactionBtn2: {
    background: '#28677d !important',
    textTransform: 'none !important',
  },
  chTransactionBtn3: {
    background: '#3894a5 !important',
    textTransform: 'none !important',
  },
  chPaperH1_TranHead: {
    fontSize: '1.5em !important',
    color: `#455a64 !important`,
    fontWeight: 'bold !important',
  },
  chPaperTran: {
    margin: `${theme.spacing(2.5)}px 0 !important`,
    padding: `${theme.spacing(2.5)}px !important`
  },
  chPaperTranNoPadding:{
    margin: `${theme.spacing(2.5)}px 0 !important`,
    padding: '0px !important'
  },
  chPaperTranInner: {
    margin: `${theme.spacing(2.5)}px 0 !important`,
    padding: `${theme.spacing(2.5)}px !important`
  },
  chPaperTranInner_t0: {
    margin: `${theme.spacing(2.5)}px 0 !important`,
    padding: `0!important`
  },
  chPaperTranInner_a0: {
    margin: `0 !important`,
    padding: `0 ${theme.spacing(2.5)}px !important`
  },
  chCardName: {
    fontSize: '0.875rem !important',
    fontWeight: 'bold !important',
    color: '#28677d !important'
  },
  chCardImg: {
    width: `${theme.spacing(20)}px !important`,
    margin: `${theme.spacing(3)}px 0!important`
  },
  chCardImgAuto: {
    width: `100% !important`,
    margin: `${theme.spacing(3)}px 0!important`
  },
  cardAmtPosLeft: {
    textAlign: 'left',
    textTransform: 'none !important'
  },
  chChip_margin: {
    margin: `${theme.spacing(2.50)}px ${theme.spacing(0.5)}px 0 0 !important`,
  },
  logoImg: {
    width: `57px !important`,
    height: `37px !important`
  },
  //#endregion

  filterContainer: {
    padding: `0 ${theme.spacing(1.5)}px ${theme.spacing(1.5)}px !important`,
    '& div': {
      margin: `0 ${theme.spacing(0.625)}px ${theme.spacing(0.625)}px 0 !important`
    }
  },
  ModalTitle: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`
  },

  //#region Timer
  timer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  timerText: {
    color: '#aaa'
  },
  timerValue: {
    fontSize: 40
  },
  //#endregion
  //#region Promotions
  promoDetailBox: {
    background: '#ededed !important',
    padding: `${theme.spacing(5)}px ${theme.spacing(12)}px !important`
  },
  promoDetailPaper: {
    padding: `${theme.spacing(2.5)}px !important`,
    borderRadius: `${theme.spacing(3)}px !important`,
    background: '#ededed !important',
    boxShadow: '20px 20px 40px #c9c9c9, -20px -20px 40px #ffffff',
    '& img': {
      maxWidth: 250,
      borderRadius: `${theme.spacing(3)}px !important`
    }
  },
  //#endregion
  //#region Verbs
  ch_verb_get: {
    background: green[500],
    color: '#fff !important'
  },
  ch_verb_post: {
    background: amber[700],
    color: '#fff !important'
  },
  ch_verb_put: {
    background: blue[700],
    color: '#fff !important'
  },
  ch_verb_delete: {
    background: red[500],
    color: '#fff !important'
  },
  ch_verb_patch: {
    background: grey[900],
    color: '#fff !important'
  },
  //#endregion
  unAuthorizedPaper: {
    width: '50vw',
    padding: `${theme.spacing(2.5)}px !important`,
    borderRadius: `${theme.spacing(3)}px !important`,
    background: `${theme.palette.background.default} !important`,
    boxShadow: '20px 20px 40px #c9c9c9, -20px -20px 40px #ffffff',
    '& img': {
      width: '100% !important'
    },
    [theme.breakpoints.between('xs', 'sm', 'md')]: {
      width: '100%'
    }
  },
  fullHeight: {
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight * 3}px)`
  },
  no_padding: {
    padding: '0px !important'
  },
  cardholder_transaction_container:{
    //background:'red',
    display:'flex'
  },
  cardholer_google_map:{
    width:'33%',
    boxSizing:'border-box',
    paddingRight:16,
    transition:'all 0.4s linear'
  },
  cardholer_google_map_hidden:{
    width:80,
    transition:'all 0.4s linear'
  },
  crh_transaction_d:{
    width:'67%',
    //background:'blue',
    transition:'all 0.4s linear'
  },
  crh_transaction_d_expandable:{
    width:'calc(100% - 80px)',
    //background:'blue',
    transition:'all 0.4s linear'
  }
}))
export default useStyles